import { configureStore, Middleware } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { apiRegistry } from './api-register';

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }).concat(
      ...(apiRegistry.map(api => api.middleware) as Middleware[]),
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
